var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTea = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Tea-Cup--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Tea Cup Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.75 22H1.25a1 1 0 0 0 0 2h19.5a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6.71a1 1 0 0 0 0.7 0.29 1 1 0 0 0 0.71 -0.29 1 1 0 0 0 0 -1.42 0.75 0.75 0 0 1 0 -1.08 2.78 2.78 0 0 0 0 -3.92A1 1 0 0 0 5 0.29a1 1 0 0 0 0 1.42 0.77 0.77 0 0 1 0 1.08 2.78 2.78 0 0 0 0 3.92Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53 6.71a1 1 0 0 0 0.7 0.29 1 1 0 0 0 0.71 -0.29 1 1 0 0 0 0 -1.42 0.75 0.75 0 0 1 0 -1.08 2.78 2.78 0 0 0 0 -3.92 1 1 0 0 0 -1.41 0 1 1 0 0 0 0 1.42 0.77 0.77 0 0 1 0 1.08 2.78 2.78 0 0 0 0 3.92Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.71a1 1 0 0 0 0.7 0.29 1 1 0 0 0 0.71 -0.29 1 1 0 0 0 0 -1.42 0.75 0.75 0 0 1 0 -1.08 2.78 2.78 0 0 0 0 -3.92 1 1 0 0 0 -1.41 0 1 1 0 0 0 0 1.42 0.77 0.77 0 0 1 0 1.08 2.78 2.78 0 0 0 0 3.92Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8h-9.5a0.25 0.25 0 0 0 -0.25 0.25V10a0.24 0.24 0 0 0 0.14 0.22A2 2 0 0 1 10.25 12v2.5a0.5 0.5 0 0 1 -0.5 0.5h-3a0.5 0.5 0 0 1 -0.5 -0.5V12a2 2 0 0 1 1.11 -1.79 0.24 0.24 0 0 0 0.14 -0.21V8.25A0.25 0.25 0 0 0 7.25 8h-4a1 1 0 0 0 -1 1v3.5a8 8 0 0 0 8.53 8 7.79 7.79 0 0 0 5.11 -2.4 0.25 0.25 0 0 1 0.18 -0.08h2.68a5 5 0 0 0 0 -10Zm0 8h-1a0.26 0.26 0 0 1 -0.21 -0.11 0.29 0.29 0 0 1 0 -0.24 8.39 8.39 0 0 0 0.73 -3.42V10.5a0.5 0.5 0 0 1 0.5 -0.5 3 3 0 0 1 0 6Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTea);
export default ForwardRef;